const DEFAULT_CONFIG = {
  api: 'https://globalrecalls-st.oecd.org/ws',
  "GATrackingID": "UA-122933294-1",
  dashboardAPI: 'http://gen-api-dev-1.main.oecd.org:8300/ws'
};

let LOADED_CONFIG = null;

export function getConfig() {
  if (LOADED_CONFIG) return Promise.resolve(LOADED_CONFIG);
  return fetch('app-config.json')
    .then(resp => {
      return resp.ok ? resp.json() : {}
    })
    .then(config => {
      LOADED_CONFIG = Object.assign({}, DEFAULT_CONFIG, config);
      return LOADED_CONFIG;
    });
}


// WEBPACK FOOTER //
// ./src/config/index.js